import { Subject, combineLatest, BehaviorSubject } from "rxjs";
import {
  startWith,
  switchMap,
  tap,
  filter,
  map,
  share,
  withLatestFrom,
} from "rxjs/operators";
import { ajax } from "rxjs/ajax";
import { flatten, uniq } from "ramda";
import Item from "./item";

import { organizations$ } from "./organizations";

export const SEARCH_STATES = {
  IDLE: "IDLE",
  LOADING: "LOADING",
  LOADED: "LOADED",
};

export const searchState$ = new BehaviorSubject(SEARCH_STATES.IDLE);

export const search$ = new Subject();

export const groups$ = organizations$.pipe(
  filter((orgs) => orgs.length > 0),
  map((orgs) => flatten(orgs.map((org) => org.groups))),
  share()
);

export const searchTerm$ = new Subject();

export const searchResults$ = combineLatest([search$, groups$]).pipe(
  filter(([term, groups]) => term.length > 0 && groups.length > 0),
  tap(() => searchState$.next(SEARCH_STATES.LOADING)),
  switchMap(([text, groups]) => {
    searchTerm$.next(text);
    const groupIds = groups.map((group) => group.id);
    const filterByGroupIds = `any(${groupIds.join(",")})`;
    const url = `https://hub.arcgis.com/api/v3/datasets?q=${text}&filter[groupIds]=${filterByGroupIds}&page[size]=99`;
    return ajax(url);
  }),
  withLatestFrom(searchTerm$),
  map(([data, text]) => {
    let items = [];
    if (/['||"]/.test(text)) {
      const name = text.toLowerCase().substring(1, text.length - 1);
      const filtered = data.response.data.filter((result) =>
        result.attributes.name.toLowerCase().includes(name)
      );
      items = filtered;
    } else items = data.response.data;
    return items.map((result) => Item.from(result));
  }),
  tap(() => searchState$.next(SEARCH_STATES.LOADED)),
  startWith([]),
  share()
);
